'use client';
import React from 'react';
import {
  RadarChart,
  Radar,
  PolarGrid,
  PolarAngleAxis,
  ResponsiveContainer,
  Tooltip,
} from 'recharts';

interface RatingRadarChartProps {
  dimensions: {
    relevance: number;
    depth: number;
    clarity: number;
    responsiveness: number;
    value: number;
  };
}

interface TooltipPayload {
  value: number;
}

interface CustomTooltipProps {
  active?: boolean;
  payload?: TooltipPayload[];
  label?: string;
}

function CustomTooltip({ active, payload, label }: CustomTooltipProps) {
  if (!active || !payload?.length) return null;
  return (
    <div className="surface-elevated px-3 py-2 text-xs font-mono-data">
      <span className="text-muted-foreground capitalize">{label}: </span>
      <span className="text-primary font-semibold">{payload[0].value.toFixed(1)}</span>
    </div>
  );
}

export default function RatingRadarChart({ dimensions }: RatingRadarChartProps) {
  const data = [
    { subject: 'Relevance', value: dimensions.relevance, fullMark: 5 },
    { subject: 'Depth', value: dimensions.depth, fullMark: 5 },
    { subject: 'Clarity', value: dimensions.clarity, fullMark: 5 },
    { subject: 'Responsive', value: dimensions.responsiveness, fullMark: 5 },
    { subject: 'Value', value: dimensions.value, fullMark: 5 },
  ];

  return (
    <ResponsiveContainer width="100%" height="100%">
      <RadarChart data={data} margin={{ top: 10, right: 20, bottom: 10, left: 20 }}>
        <PolarGrid stroke="var(--border)" />
        <PolarAngleAxis
          dataKey="subject"
          tick={{ fill: 'var(--muted-foreground)', fontSize: 11, fontFamily: 'var(--font-ibm-plex-mono)' }}
        />
        <Radar
          name="Rating"
          dataKey="value"
          stroke="var(--primary)"
          fill="var(--primary)"
          fillOpacity={0.15}
          strokeWidth={2}
        />
        <Tooltip content={<CustomTooltip />} />
      </RadarChart>
    </ResponsiveContainer>
  );
}